import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

const ENTITY_CHANGE_EVENTS: Array<'created' | 'updated' | 'deleted'> = ['created', 'updated', 'deleted'];

/**
 * Fires whenever a Workspace changes. Payload is entityId-only; callers refetch
 * the workspaces list they render. Mirrors the native home strip / morning-brief
 * subscribers on the same `individuals-workspace` channel.
 */
export function useWorkspaceDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.WORKSPACE, () => onChange(), ENTITY_CHANGE_EVENTS);
}
